seedWebApp.controller('LogisticsController', ['$scope', '$uibModal', '$rootScope','LogisticsService', 'ToastService','StoreService','DocService',
    function ($scope, $uibModal,$rootScope, LogisticsService, ToastService, StoreService, DocService) {

        $scope.prefs = {
            name: 'IssuesGrid',
            sortByCol: null,
            canAdd: false,
            canEdit: true,
            canDelete: false,
            parentFilter: {},
            canSelect: true,
            disableLoadItems: true,
        };

        $scope.statusFilter = 'OPEN';
        $scope.selectedCount = 0;
        $scope.emailsCount = {
            EmailsSent: 0,
            EmailsNotSent: 0,
        }
        
        Date.prototype.addDays = function (days) {
            this.setDate(this.getDate() + days);
            return this;
        };

        Date.prototype.getDateWithoutTime = function () {
            return new Date(this.toDateString());
        };

        $scope.getToday = function () {
            var today = new Date();
            today = today.getDateWithoutTime();        
            return today;
        }
                
        $scope.getEmailsByDocument = function () {
            $scope.emailsLoading = true;
            $scope.emailsLoaded = false;
            LogisticsService.getEmailsByDocument().then(function (response) {
                $scope.emailsLoading = false;
                $scope.emailsLoaded = true;
                $scope.modelOptions = response.data;
                
                //console.log('emailsLoaded: ', response.data);              
                //$scope.defaultDateStart = new Date(today.addDays(-60));
                $scope.prefs.parentFilter = {
                    shipDateStart: null,
                    shipDateEnd: null,
                    invoiceDateStart: null,
                    invoiceDateEnd: null,
                    incoterms: $scope.modelOptions[0].incoterms,
                };

                $scope.filter = {
                    modelID: 'Clientes',
                    email: $scope.modelOptions[0],
                };

                $scope.selectOption($scope.modelOptions[0]);
                //console.log('parentFilter: ', $scope.prefs.parentFilter);
            }, function () {
                $scope.emailsLoading = false;
                console.log('Error loading emails');
            });
        };

        $scope.getEmailsByDocument();
                       

        $scope.selectOption = function (option) {
            $scope.filter.modelID = option.emailID;

            option.requiredFields = [];
            if (option.RequiredFields) {
               option.requiredFields =  option.RequiredFields.split(';');
            }            

            if (option.IncotermIDs && option.IncotermIDs.trim() !== '') {
                option.incoterms = option.IncotermIDs.split(';');
            } else {
                option.incoterms = []; 
            }

            option.docs = option.Docs;

            //recipients
            option.recipients = [];           
            if (option.SendToList && option.SendToRecipients) {
                var recs = option.SendToRecipients.split(';');
                recs.forEach(function (rec) {
                    if (rec != '') {
                        option.recipients.push(rec);
                    }
                });
            }
            //verificar NINGUEM
            //if (!option.recipients.length) {
            //    option.recipients.push('[NOBODY]');
            //}

            //carbon copy
            option.copies = [];
            if (option.SendToCopiesFlag && option.SendToCopiesEmails) {
                recs = option.SendToCopiesEmails.split(';');
                recs.forEach(function (rec) {
                    option.copies.push(rec);
                });
            }

            //console.log('select option', $scope.getToday());

            var today = $scope.getToday();
            var shipDateDays = -30;
            if (option.FilterByShipDate) {
                $scope.prefs.parentFilter.shipDateStart = new Date(today.addDays(shipDateDays));
                $scope.prefs.parentFilter.shipDateEnd = null;
            }
            else {
                $scope.prefs.parentFilter.shipDateStart = null;
                $scope.prefs.parentFilter.shipDateEnd = null;
            }
            var invoiceDateDays = -30;
            if (option.FilterByInvoiceDate) {
                $scope.prefs.parentFilter.invoiceDateStart = new Date(today.addDays(invoiceDateDays));
                $scope.prefs.parentFilter.invoiceDateEnd = null;
            }
            else {
                $scope.prefs.parentFilter.invoiceDateStart = null;
                $scope.prefs.parentFilter.invoiceDateEnd = null;
            }
            $scope.filter.email = option;            
            $scope.prefs.parentFilter.emailID = option.EmailID;
            $scope.prefs.parentFilter.incoterms = option.incoterms;

            $scope.prefs.parentFilter.docs = option.docs.map(function (doc) {
                return doc.DocTypeShort;
            });
            
            $scope.doRefresh();
        };
        
        $scope.loadService = LogisticsService.getOrders;
        $scope.loadColumns = LogisticsService.getOrdersColumns;
        $scope.resetService = LogisticsService.resetCache;

        $scope.getDocCountClass = function (item) {
            if (item <= 0) {
                return 'qt-orders';
            }
            else if (item > 0) {
                return 'qt-pos';
            }
        };

        $scope.getDocStatusClass = function (item) {
            if (item == 'Ready') {
                return 'qt-pos';
            }
            else {
                return 'qt-orders';
            }
        };

        $scope.getIDClass = function (item) {
            return 'agp-color';
        };

        $scope.statusClass = function (item) {
            return 'Status_Shipping Status_' + item;
        };

        $scope.docClass = function (item) {
            if ($scope.isDocRequired($scope.filter.email.docs, item))
            {
                return 'doc-required';
            }            
        };

        $scope.isDocRequired = function (docs, docTypeID) {
            if (!docs) {
                return false;
            }
            var found = docs.find(
                function (item) {
                    return item.DocTypeShort === docTypeID;
                })
            return found;
        };

        $scope.dateFormat = "MMM dd, yyyy";
        $scope.columns = [
            { name: 'ActualShippingDateDisplayable', display: 'Actual Ship Date', dataType: 'date', format: $scope.dateFormat, width: 5, filterOptions: [] },
            { name: 'InvoiceDate', display: 'Invoice Date', width: 5, dataType: 'date', format: $scope.dateFormat, isUTC: false, filterOptions: [] },
            { name: 'ShippingDate', display: 'Ship Date', dataType: 'date', format: $scope.dateFormat, isUTC: false, width: 5, filterOptions: [] },
            { name: 'VesselName', display: 'Vessel Name', width: 5, filterOptions: [] },
            { name: 'ContactID', display: 'Customer', width: 5, customClass: $scope.getIDClass, filterOptions: [] },            
            //{ name: 'ContractNumber', display: 'PO#', width: 5, filterOptions: [] },
            { name: 'ProcExpID', display: 'Invoice#', width: 5, filterOptions: [] },
            { name: 'StatusID', display: 'Status', filterOptions: [], width: 5, translationPrefix: 'Status_', tdClass: $scope.statusClass },            
            { name: 'BookingID', display: 'Booking', width: 5, filterOptions: [] },
            { name: 'IncotermID', display: 'Inc', width: 1, filterOptions: [] },            
            { name: 'DocStatus', display: 'Doc Status', width: 1, customClass: $scope.getDocStatusClass, filterOptions: [] },   
            { name: 'EmailCount', display: 'Emails', width: 1, customClass: $scope.getDocCountClass, filterOptions: [] },                           
            { name: 'DocCount', display: 'Docs', width: 1, customClass: $scope.getDocCountClass, filterOptions: [] },            
            { name: 'Docs', display: 'Document List', width: 5, dataType: 'tags', tagLimit: 10, customClass:$scope.docClass },            
        ];

        
        $scope.prefs.customEdit = function (item) {
            $scope.editItem(item);
        };

        $scope.editItem = function (item) {
            StoreService.openOrderDetailModal(item.OrderID, null);
        };

        $scope.doInsert = function () {
            $scope.editItem(null);
        };
        
        $scope.searchMode = function () {
            $scope.$broadcast('inputSearch', $scope.filterString);
        };

        $scope.doRefresh = function () {
            $scope.selectedCount = 0;
            $scope.$broadcast('refreshServiceGrid');
            $rootScope.$broadcast('delete_filter', null);
            $scope.refreshEmailCounts();            
        };

        $scope.refreshEmailCounts = function () {
            $scope.loadingCounts = true;
            LogisticsService.getEmailsCounts($scope.prefs.parentFilter)
                .then(function (response) {
                    //console.log('getEmailsCount', response);
                    $scope.emailsCount = {
                        EmailsSent: response.data.emailsSent,
                        EmailsNotSent: response.data.emailsNotSent,
                    }
                    $scope.loadingCounts = false;
                }, function (error) {
                    //console.log('getEmailsCount ERROR', error);
                    $scope.loadingCounts = false;
                }
            );

        };

        $scope.toExcel = function () {
            $scope.$broadcast('toExcel', 'chamados');
        };

        $scope.setFilter = function (status) {
            $scope.doRefresh();
        };

        $scope.clearSelected = function () {           
            //console.log('clearSelected');
            $scope.$broadcast('clearSelected');
        };

        $scope.applyFilters = function () {
            //-------------------------------------------
            //LIMPAR LISTAS DE FILTROS DAS COLUNAS
            //-------------------------------------------           
            $scope.doRefresh();
        };

        $scope.sendAll = function (items) {
            //console.log('sendAll', items);
            $scope.sendItems(items);
        };

        $scope.getSelected = function (items) {
            var selItems = [];
            if (items) {
                items.forEach(function (item) {
                    if (item.selected) {
                        selItems.push(item);
                    }
                })
            }
            return selItems;
        };

        $scope.getSelectedCount = function (items) {            
            return $scope.getSelected(items).length;
        };

        $scope.sendSelected = function (items) {
            //console.log('sendSelected', items);
            var selItems = $scope.getSelected(items);            
            $scope.sendItems(selItems);
        };

        $scope.sendItems = function (items) {            
            //console.log('sendItems', items);
            //var MAX_ORDERS = 100;
            //if (items.length > MAX_ORDERS) {
            //    ToastService.createToast('Error', 'Limite máximo de ' + MAX_ORDERS + ' pedidos por email', 4000, 'error');
            //    return;
            //}
            var modalInstance = $uibModal.open({
                templateUrl: './SPA/Logistics/sendEmailModal.html' + seedWebApp.buildVersion,
                controller: 'SendEmailModalController',
                size: 'xl',
                resolve: {
                    items: function () {
                        return items;
                    },
                    filter: function () {
                        return $scope.filter;
                    },
                    email: function() {
                        return $scope.filter.email;
                    }
                }
            });
            modalInstance.result.then(function (status) {
                //console.log('email send', status);
                $scope.doRefresh();
            });          
        };

        $scope.refreshDocuments = function (items) {            
            var selItems = $scope.getSelected(items);            
            var orders = selItems.map(
                function (order) {
                    return {
                        OrderID: order.OrderID,
                    }
                }
            );
            //console.log('refreshDocuments', orders);
            var toastID = ToastService.createToast('Executing', 'Refresh Documents from FTP', 8000, 'wait');
            DocService.recreateSelectedOrderDocs(orders).then(function (response) {                
                $scope.doRefresh();
                ToastService.updateToast(toastID, 'Loaded', 'Filled!', 4000, 'success');
            }, function (error) {
                console.log('Error REFRESHING');
                ToastService.updateToast(toastID, 'Error Refreshing', $scope.getErrorMessage(error), 4000, 'error');
            });
        };

    }
]);
